import { Component, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { Color, ScaleType } from "@swimlane/ngx-charts";
import { BaseComponent } from "../../../base-module/base-component/base.component";

/** Components */

/** Services */
import { DateFilterFn, MatDatepickerInputEvent } from "@angular/material/datepicker";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from "@fuse/animations";
import { AuthService } from "app/base-module/base-service/auth.service";
import { ClientEquityModel } from "app/clientes/models/client-equity.model";
import { ClienteModel } from "app/clientes/models/cliente.model";
import { ClientEquityService } from "app/clientes/services/client-equity.service";
import { ImportacaoArquivoService } from "app/movimentacao/services/importacao-arquivo.service";
import { Usuario } from "app/usuarios/models/user.model";
import { DateUtils } from "src/utils/date-utils";
import { ClienteProdutoService } from "../../services/cliente-produto.service";
import { ClienteService } from "../../services/cliente.service";
export interface DialogData {
    id: number;
}

@Component({
    selector: "dialog-cliente-cadastro-painel",
    templateUrl: "./cadastro-completo-painel.component.html",
    styleUrls: ["./cadastro-completo-painel.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [ClienteProdutoService, ClientEquityService],
})
export class CadastroCompletoPainelComponent extends BaseComponent {
    gradient: boolean = true;
    showLegend: boolean = true;
    showLabels: boolean = true;
    isDoughnut: boolean = false;
    equity: ClientEquityModel[] = [];

    cliente!: ClienteModel;

    view: [number, number] = [1200, 200];
    vlr_boleta_fo = new FormControl("", []);
    vlr_boleta_st = new FormControl("", []);
    vlr_boleta_fii = new FormControl("", []);
    desconto_corretagem = new FormControl("", []);
    patrimonio_geral = new FormControl("", []);
    despesas_mensais = new FormControl("", []);
    receita_mensal = new FormControl("", []);
    receita_familiar = new FormControl("", []);
    situacao_tributaria = new FormControl("", []);
    codigo_xp = new FormControl("", []);
    today_date = new Date();
    yesterday = new Date(this.today_date.getFullYear(), this.today_date.getMonth(), this.today_date.getDate());
    data_agenda = new FormControl();

    total_prosperidade = new FormControl(0, []);
    sow = new FormControl(0, []);
    saldo_conta = new FormControl(0, []);

    operacao_stop = new FormControl();
    estado_civil_id = new FormControl();
    sexo = new FormControl();
    fundos = new FormControl();
    renda_fixa = new FormControl();
    renda_variavel = new FormControl();
    suitability = new FormControl();
    valor_internacional = new FormControl();

    isHabilityRendaVariavelClient: boolean = false;
    isHabilityExtractClient: boolean = false;
    datas_disponiveis: any[] = [];
    isDisabledDate: boolean = true;

    colorScheme: Color = {
        // Corrigido para usar o tipo Color
        name: "custom",
        selectable: true,
        group: ScaleType.Ordinal,
        domain: ["#00D680", "#FCCD00", "#A18857", "#FD8E00", "#00AAE5", "#BA6BC6"],
    };

    data: any = {};
    data_atualizacao: any;

    exibeValorInicial: boolean = true;
    isConditionIsTrue: boolean = true;

    totalCustodiaFop: any = 0;
    totalCustodiaSt: any = 0;
    totalCustodiaFii: any = 0;

    isDisabledAssessor: boolean = true;

    @ViewChild("addButtonTmpl", { static: false })
    addButtonTmpl!: TemplateRef<any>;
    @ViewChild(CadastroCompletoPainelComponent, { static: false })
    table!: CadastroCompletoPainelComponent;
    @ViewChild("paginatorRelacionamento", { static: false })
    paginatorRelacionamento!: MatPaginator;

    user: Usuario;

    constructor(
        public service: ClienteService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private _Activatedroute: ActivatedRoute,
        private route: Router,
        private _authService: AuthService,
        public _arquivoService: ImportacaoArquivoService,
        private _custodiaCliente: ClienteProdutoService,
        private _equityClientService: ClientEquityService
    ) {
        super(dialog, snackBar);
        this.data = this._Activatedroute.snapshot.params["id"];
        const strUser = this._authService.getUser();
        try {
            this.user = JSON.parse(strUser || "{}") as Usuario;
        } catch (e) {
            this.user = {} as Usuario;
            console.error("Error parsing user from localStorage", e);
        }
        this.initAplication();
    }

    initAplication() {
        this.getLastDateUpdate();
        this.getCliente();
        this.getEquityClient({ cliente_id: this.data });
        this.addDateYesterdayDate();
    }

    addDateYesterdayDate() {
        this.yesterday.setDate(this.yesterday.getDate() - 1);
        this.data_agenda.setValue(this.yesterday);
    }

    onSelect(data: any): void {
        const selectedItem = JSON.parse(JSON.stringify(data));

        if (selectedItem.name == "RENDA VARIÁVEL") {
            this.isHabilityRendaVariavelClient = true;
            this.isHabilityExtractClient = false;
        } else {
            this.isHabilityRendaVariavelClient = false;
            this.isHabilityExtractClient = false;
        }
    }

    changeExtractClient(event: any): void {
        this.isHabilityExtractClient = event;
    }

    changeInfoClient() {
        this.isHabilityRendaVariavelClient = false;
        this.isHabilityExtractClient = false;
    }

    realValueFormat(c: any): any {
        return parseFloat(c).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
    }

    percentValueFormat(c: any): any {
        return parseFloat(c).toFixed(2);
    }

    getEquityClient(parametros: any) {
        this._custodiaCliente.getAll(parametros).subscribe(
            (list) => {
                this.equity = list.data;
            },
            (error) => {},
            () => {}
        );
    }

    getValorFinanceiro(row: any) {
        if (row.preco_executado > 0) {
            return parseFloat(row.qtd) * parseFloat(row.preco_executado);
        } else {
            return row.vlr_financeiro;
        }
    }

    getCliente() {
        this.openLoading();
        this.service.getById(this.data).subscribe(
            (cliente) => {
                this.cliente = cliente.data;
                this.getDateAvailable({ cliente_id: this.data });
            },
            (error) => {
                this.closeLoading();
            },
            () => {
                this.closeLoading();
            }
        );
    }

    retornarLista() {
        this.route.navigate(["/clientes/consulta"]);
    }

    getValueZero(value: any) {
        if (value == undefined || value == null || value == "") {
            return 0.0;
        }

        return parseFloat(value);
    }

    diasDisponiveis: DateFilterFn<Date | null> = (d: Date | null): boolean => {
        if (!d) {
            return false;
        }

        const date = new Date(d);
        return this.datas_disponiveis.includes(DateUtils.parseDateToPtBr(date));
    };

    changeDateAvailable(e: MatDatepickerInputEvent<Date>) {
        const date: Date | null = e.value;
        const parametros = {
            data_refencia_mes: (date ?? new Date()).toISOString().slice(0, 10),
            cliente_id: this.data,
        };

        this.getEquityClient(parametros);
    }

    getDateAvailable(parametros: object) {
        this.isDisabledDate = true;
        this._equityClientService.getAllDateHistoryInvestiments(parametros).subscribe(
            (list) => {
                this.datas_disponiveis = list.data;
                if (this.datas_disponiveis != undefined && this.datas_disponiveis.length > 0) {
                    this.isDisabledDate = false;
                }
            },
            (error) => {
                this.showError(error.error.message);
                this.isDisabledDate = true;
            },
            () => {}
        );
    }

    getLastDateUpdate() {
        this._equityClientService.getLastUpdate().subscribe(
            (list) => {
                this.data_agenda.setValue(list.data);
            },
            (error) => {
                this.showError(error.error.message);
            },
            () => {}
        );
    }

    editFichaCadastral() {
        this.route.navigate(["/clientes/ficha-cadastral/" + this.data]);
    }
}
